module.exports = __webpack_public_path__ + "static/img/plat2.36b17e3f.png";